import Enums from "../../../enums/enums";

const state = {
  sendEmailVerificationLoadingStatus: Enums.LoadingStatusType.None,
  verifyEmail: null,
  verifyEmailLoadingStatus: null,
};

const getters = {
  GetSendEmailVerificationLoadingStatus: (state) => {
    return state.sendEmailVerificationLoadingStatus;
  },
  GetVerifyEmail: (state) => {
    return state.verifyEmail;
  },
  GetVerifyEmailLoadingStatus: (state) => {
    return state.verifyEmailLoadingStatus;
  },
};
export { getters, state };
